import React, { useContext, useEffect, useState } from "react";
import config from "appConfig";
import { connect, useDispatch, useSelector } from "react-redux";
import styles from "./adDetailsPageMobile.scss";
import SummarySection from "./SummarySection";
import { getModuleContext } from "../../../HOCs";
import { LocalStorageKey, CurrentPage, AdStatus, PageRoute, PermutiveEvents, HashTag, ModuleNameHr, ModuleName, CategoryName, CategoryNameHr } from "../../../models/enums";
import {
  selectAdDetails,
  getAdDetails,
  updateViewCount,
  getCreatorInfo,
  setForbidAds,
  selectForbidAds,
  selectIsAgeVerified,
  getAdStatistics
} from "../../../routes/Ad/ad.ducks";
import { selectFavoriteIds } from "../../../routes/Favorite/favorite.ducks";
import {
  selectCategories,
  selectCurrentCategories,
  selectModules
} from "../../App/selectors";
import { checkEmptyObject, scrollToTop, buildBaseUrl, PermutiveEventData, checkEmptyArray, localStorage } from "../../../services";
import DetailsSection from "./DetailsSection";
import { Loading } from "../../../components/Loading";
import utilsStyles from "./../../../styles/utils.scss";
import SpecialSectionMobile from "./SpecialSectionMobile";
import ContactSection from "./ContactSection";
import EmailDealerModal from "./EmailDealerModal";
import SimilarAdsSection from "./SimilarAdsSection";
import { selectLoadedUser, selectUserInfo } from "../../../routes/Auth/auth.ducks";
import TipsSection from "../AdDetailsPageWeb/TipsSection";
import BreadcrumbBar from "../../../components/BreadcrumbBar";
import HelmetComponent from "../../../utils/HelmetHelper";
import { buildAdDetailStructuredData } from "../../../utils/buildAdDetailStructuredData";
import { useMakes } from "../../../routes/Configuration";
import { getIconUrl, getImageLink } from "../../../services/asset";
import ReactGA from "react-ga4";
import { Context } from "../../../GAContext";
import { googleAds } from "appConfig";
import { truncate } from "../../../utils/truncateWord";
import { useInView } from "react-intersection-observer";
import ActionBar from '../ActionBar';
import AdDetailsMobileLoader from "./AdDetailsMobileLoader";
import { Modal } from "antd";
import GoogleAd from "../../../components/GoogleAd";
import GoogleAdInterstitial from "../../../components/GoogleAdInterstitial";
import history, { navigateToLogin } from "../../../history";
import useHrPageName from "../../../utils/useHrPageName";
import AgeVerification from "../../../components/AgeVerificationModal";
import PriceComparison from "../PriceComparison";
import MakeModelInfoCta from "../../../components/MakeModelInfoCta";
import OwnAdBanner from "../OwnAdBanner";
import OwnAdPanel from "../OwnAdPanel";
import { usePhoneReveal } from "../../../hooks/usePhoneReveal";
import TurnstileChallenge from "../../../components/TurnstileChallenge";
import { notification } from "../../../services";
import { RealEstateWidget } from "../../ModulePage/RealEstatePricesEntryBox/RealEstateWidget";
import { isPropertyTypeSlug } from "../../RealEstatePricesPage/helpers";


function AdDetailsPageMobile(props: any) {
  const {
    match: {
      params: { id }
    },
    adDetails,
    getAdDetails,
    updateViewCount,
    getCreatorInfo,
    user,
    userRaw,
    categories,
    modules,
    favoriteIds,
  } = props;
  const [emailDealerModalVisible, setEmailDealerModalVisible] = useState(false);
  const [phoneModalVisible, setPhoneModalVisible] = useState(false);
  const adSummaryId = adDetails && adDetails.summary && adDetails.summary.id;
  const hasPhones = adDetails && adDetails.summary && adDetails.summary.hasPhones;
  const phoneReveal = usePhoneReveal({ kind: "ad", id: adSummaryId });
  const { state: phoneRevealState, phones, hardLimitMessage, reveal: revealPhones } = phoneReveal;
  const [GaEvent, setGaEvent] = useContext(Context);
  const forbiddAds = useSelector(selectForbidAds);
  const isAgeVerified = useSelector(selectIsAgeVerified);
  const dispatch = useDispatch();
  const [ageVerificationModal, setAgeVerificationModal] = useState(false);
  const [loadingSimilar, setLoadingSimilar] = useState(false);
  const hrPageName = useHrPageName(adDetails && adDetails.category, adDetails && adDetails.module);
  const currentCategories = useSelector(selectCurrentCategories)
  const { ref: similarRef, inView } = useInView({ triggerOnce: true });

  // Makes dataset for JSON-LD `brand` / `model` lookup — only fetched for
  // personal-car ads where the identifier matters for Google rich results.
  // Empty string → useMakes skips the fetch and returns undefined.
  const adModule = adDetails && adDetails.module;
  const adCategory = adDetails && adDetails.category;
  const isCarAd =
    (adModule === ModuleName.vehicles || adModule === ModuleNameHr.vehicles) &&
    (adCategory === CategoryName.car || adCategory === CategoryNameHr.car);
  const makes = useMakes(isCarAd ? CategoryName.car : "");

  const isLoading = () => {
    const {
      adDetails,
      match: {
        params: { id: adCode }
      }
    } = props;
    return (
      !checkEmptyObject(adDetails) ||
      !checkEmptyObject(adDetails.summary) ||
      (adCode !== adDetails.summary.code.toString() &&
        adCode !== adDetails.summary.id)
    )
  };

  useEffect(() => {
    if (!user || !checkEmptyObject(adDetails)) return;
    const contactAfterLogin = history.location.hash === HashTag.contactAfterLogin;

    if (contactAfterLogin) {
      onChatClick();
    }

  }, [user, adDetails]);

  useEffect(() => {
    setGaEvent(CurrentPage.details);
    scrollToTop();
    saveVisitedAd();
    return () => {
      setGaEvent("");
    };
  }, []);

  useEffect(() => {
    loadAdDetails(props);
  }, [
    id,
    adDetails !== null,
    favoriteIds,
    userRaw,
  ]);

  useEffect(() => {
    return () => {
      PermutiveEventData.clear(PermutiveEvents.AdPreview, id);
    }
  }, [id]);

  useEffect(() => {
    if (
      adDetails &&
      adDetails.summary &&
      adDetails.summary.id &&
      !isLoading()
    ) {
      updateViewCount(adDetails.summary.id);
    }
  }, [checkEmptyObject(adDetails)
    && JSON.stringify(adDetails.summary)
    && adDetails.summary.id
    && !isLoading()]);

  useEffect(() => {
    if (!adDetails || !adDetails.category) {
      return;
    }
    handleForbiddenAds();
  }, [modules, categories, adDetails && adDetails.category]);

  // Own-ad banner (page position) and panel (phone-click count) both read
  // from the same statistics slice, so we fetch it once at the page level.
  const isOwnAd = Boolean(
    adDetails && adDetails.creator && user && adDetails.creator.id === user.userId
  );
  useEffect(() => {
    if (isOwnAd && adSummaryId) {
      dispatch(getAdStatistics(adSummaryId));
    }
  }, [isOwnAd, adSummaryId]);

  const handlePhoneModalOpen = () => {
    setPhoneModalVisible(true);
  };

  const handlePhoneModalCancel = () => {
    setPhoneModalVisible(false);
  };

  // After a successful reveal we branch on how many numbers came back:
  // exactly one → jump straight to the tel: link (matches old behaviour),
  // more than one → open picker modal.
  useEffect(() => {
    if (phoneRevealState !== "revealed" || phones.length === 0) return;
    if (phones.length === 1) {
      document.location.href = `tel:${phones[0].number}`;
    } else {
      handlePhoneModalOpen();
    }
  }, [phoneRevealState, phones]);

  useEffect(() => {
    if (phoneRevealState === "hardLimit") {
      notification.showError(
        hardLimitMessage || "Prekoračili ste dnevni limit pregleda telefonskih brojeva. Pokušajte ponovno kasnije."
      );
    }
  }, [phoneRevealState, hardLimitMessage]);

  const handleCallPhoneClick = () => {
    ReactGA.event({
      category: "Detalji oglasa",
      action: "Click",
      label: `Klik na telefon - ${hrPageName}`
    });

    // If numbers are already revealed in this session, reuse them —
    // otherwise trigger the reveal (which may respond with a captcha
    // challenge; that is handled by the modal below).
    if (phoneRevealState === "revealed" && phones.length > 0) {
      if (phones.length === 1) {
        document.location.href = `tel:${phones[0].number}`;
      } else {
        handlePhoneModalOpen();
      }
      return;
    }
    revealPhones();
  };

  const callCertainPhone = phone => {
    document.location.href = `tel:${phone}`;
  };

  const handleForbiddenAds = () => {
    const { categories, modules, module: currentModule, adDetails } = props;

    if (!checkEmptyObject(adDetails)) {
      return;
    }
    if (adDetails && adDetails.summary && adDetails.summary.is18Old) {
      dispatch(setForbidAds(true));
      setAgeVerificationModal(true);
      return;
    }

    modules.forEach(module => {
      if (module.name == currentModule) {
        if (module.is18Old) {
          dispatch(setForbidAds(true));
          setAgeVerificationModal(true);
        } else {
          dispatch(setForbidAds(false));
          setAgeVerificationModal(false);

          return;
        }
      }
    });

    categories.forEach(cat => {
      if (cat.route == adDetails.category) {
        if (cat.is18Old) {
          dispatch(setForbidAds(true));
          setAgeVerificationModal(true);
        } else {
          dispatch(setForbidAds(false));
          setAgeVerificationModal(false);
        }
      }
    });
  };

  const loadAdDetails = (nextProps: any) => {
    const {
      match: {
        params: { id: adCode }
      },
      favoriteIds,
      module,
      userRaw,
    } = nextProps;

    if (favoriteIds && module) {
      getAdDetails(
        module,
        adCode,
        getCreatorInfo,
        favoriteIds,
        userRaw
      );
    }
  };

  const closeEmailDealerModal = () => {
    setEmailDealerModalVisible(false);
  };


  const saveVisitedAd = () => {
    const {
      match: {
        params: { id }
      }
    } = props;
    let codes = localStorage.getItem(LocalStorageKey.visitedAd) || [];

    if (!codes.includes(id)) {
      codes.unshift(id);
      codes = codes.slice(0, config.localStorageLimits.visitedAd);
      localStorage.setItem(LocalStorageKey.visitedAd, codes);
    }
  };

  const openEmailDealerModal = () => {
    ReactGA.event({
      category: "Detalji oglasa",
      action: "Click",
      label: `Email dugme - ${hrPageName}`
    });

    if (user) {
      setEmailDealerModalVisible(true);
    } else {
      navigateToLogin(window.location.href + HashTag.contactAfterLogin);
    }
  };

  const onChatClick = () => {
    ReactGA.event({
      category: "Detalji oglasa",
      action: "Click",
      label: `chat button - ${hrPageName}`
    });

    if (user) {
      history.push(`${PageRoute.chats}?adId=${adDetails.summary.id}`)
    } else {
      navigateToLogin(`/oglasi${PageRoute.chats}?adId=${adDetails.summary.id}`);
    }
  };

  // if AgeVerification state is not calculated yet, we should not render the ads
  if (!ageVerificationModal && (!checkEmptyArray(categories) || !checkEmptyArray(modules))) {
    return null;
  }

  const adLoaded = adDetails && adDetails.summary;
  const sharingConfig = adLoaded ? adDetails.sharingConfiguration : null;
  const header = sharingConfig && sharingConfig.header;
  const description = sharingConfig && sharingConfig.description;
  const imageId = sharingConfig && sharingConfig.imageId;

  const canonical = adLoaded && adDetails.redirectData ? buildBaseUrl(
    "/" +
    adDetails.redirectData.module + "/" +
    adDetails.redirectData.category +
    PageRoute.details + "/" +
    adDetails.redirectData.smartLink + "/" +
    adDetails.redirectData.code
  ) : null;

  const pageTitle = adLoaded ? `${header ? header : adDetails.summary.title} | ${"INDEX OGLASI"}` : undefined;
  const pageDesc = adLoaded ? truncate(description ? description : adDetails.summary.description, 157) : undefined;
  // FB-sized (1200x630) image for OG — small enough that WhatsApp/Viber
  // can fetch it within their timeout (the full-size original often is
  // not, which is why those scrapers were falling back to the site logo).
  // Discover still gets high-res images via the Product JSON-LD below.
  const ogImageName = adLoaded && (imageId || (adDetails.summary.images && adDetails.summary.images[0]));
  const pageOgImage = ogImageName ? getImageLink(ogImageName, "fb") : undefined;
  const adStructuredData = adLoaded ? buildAdDetailStructuredData(adDetails, makes) : [];

  // AgeVerification short-circuits for 18+ ads; Googlebot has no cookie
  // so it would land on an empty document otherwise. Keep the Helmet
  // alongside so crawlers still see the metadata (same for the loading
  // skeleton — safe no-op when adDetails hasn't landed yet).
  const metaHelmet = adLoaded ? (
    <HelmetComponent
      title={pageTitle}
      ogTitle={pageTitle}
      ogImage={pageOgImage}
      ogImageWidth={pageOgImage ? 1200 : undefined}
      ogImageHeight={pageOgImage ? 630 : undefined}
      desc={pageDesc}
      canonical={canonical}
      ogType="website"
      structuredData={adStructuredData}
    />
  ) : null;

  if (ageVerificationModal && isAgeVerified !== true) {
    return (
      <React.Fragment>
        {metaHelmet}
        <AgeVerification />
      </React.Fragment>
    );
  }

  if (isLoading()) {
    return <AdDetailsMobileLoader />;
    //return <Loading className={`${utilsStyles.PT20} ${utilsStyles.PB20}`} />;
  }

  const showViewedCount = isOwnAd;

  const refetchAdDetails = () => {
    loadAdDetails(props);
  };

  return (
    <React.Fragment>
      {
        !forbiddAds &&
        <GoogleAdInterstitial
          config={{
            ...googleAds.interstitialSlot,
            id: "googleAds.interstitialSlot"
          }}
        />
      }
      <div className={styles.wrapper}>
        {metaHelmet}
        {user && (
          <EmailDealerModal
            adId={adDetails.summary.id}
            isVisible={emailDealerModalVisible}
            closeModal={closeEmailDealerModal}
            // @ts-ignore
            setVisible={e => setEmailDealerModalVisible(e)}
            category={adDetails.category}
          />
        )}
        <BreadcrumbBar
          className={styles.breadcrumbBar}
          routeLinks={adDetails.routeLinks}
          category={adDetails.category}
          backDisabled={false}
        />
        {adDetails.summary.status === AdStatus.sold && (
          <div className={styles.content}>
            <div className={styles.notifications}>
              <div className={styles.sold}>
                <img
                  alt={"Ovaj oglas je prodan!"}
                  src={getIconUrl("notification-white.svg")}
                />
                <span className={styles.text}>
                  {"Ovaj oglas je prodan!"}
                </span>
              </div>
            </div>
          </div>
        )}
        {isOwnAd && adDetails.summary.status === AdStatus.active && !adDetails.summary.isPromoted && (
          <div className={styles.content}>
            <OwnAdBanner
              adId={adDetails.summary.id}
              title={adDetails.summary.title}
              imageName={adDetails.summary.images && adDetails.summary.images[0]}
            />
          </div>
        )}

        <div className={styles.content}>
          <SummarySection
            adSummary={adDetails.summary}
            // @ts-ignore
            creator={adDetails.creator}
            onSendEmailClick={openEmailDealerModal}
            showViewedCount={showViewedCount}
            category={adDetails.category}
            module={adDetails.module}
            specialAttributes={adDetails.specialAttributes}
          />
          {isOwnAd && (
            <OwnAdPanel
              adId={adDetails.summary.id}
              adStatus={adDetails.summary.status}
              module={adDetails.module}
              category={adDetails.category}
              viewCount={adDetails.summary.viewCount || 0}
              favoriteCount={adDetails.summary.favoriteCount || 0}
              isXml={Boolean(adDetails.summary.externalId)}
              onRefetch={refetchAdDetails}
            />
          )}
          {forbiddAds ? null : (
            <GoogleAd
              className={`${styles.ads} ${utilsStyles.PB4} ${utilsStyles.PT4} `}
              config={{
                ...googleAds.detailPageMobile.box1,
                id: "googleAds.detailPageMobile.box1"
              }}
            />
          )}
          <SpecialSectionMobile
            specialAttributes={adDetails.specialAttributes}
            ad={{
              id: adDetails.summary.id,
              module: adDetails.module,
              category: adDetails.category,
            }}
            adSummary={adDetails.summary}
            category={adDetails.category}
            details={adDetails.details}
          />

          {
            forbiddAds &&
              adDetails.categoryLv1Id === "7ed638ad-724e-40c6-8760-d0e8e62428e4" && (
                adDetails.categoryLv2Id === "1b8ec9f6-461d-4a03-ae25-272d20c87f74" ||
                adDetails.categoryLv2Id === "329d4fdb-27dc-4cb1-9cf2-0870c342e36b"
              ) ? (
              <div className={styles.note}>
                Prodaja isključivo uz predočenje važeće dozvole za posjedovanje oružja. Preuzimanje osobno.
              </div>
            ) : null
          }

          <DetailsSection
            adDetails={adDetails.details}
            specialAttributes={adDetails.specialAttributes}
            category={adDetails.category}
            adId={adDetails.summary.id}
            hrPageName={hrPageName}
            insertAfterSectionName="Osnovne informacije"
            extraContent={
              <MakeModelInfoCta
                module={adDetails.module}
                category={adDetails.category}
                infoPage={adDetails.summary.infoPage}
              />
            }
          />

          <PriceComparison adSummary={adDetails.summary} category={adDetails.category} module={adDetails.module} />

          {forbiddAds ? null : (
            <GoogleAd
              className={`${styles.ads} ${utilsStyles.MT0} ${utilsStyles.PT4}`}
              config={{
                ...googleAds.detailPageMobile.box3,
                id: "googleAds.detailPageMobile.box3"
              }}
            />
          )}
          {/* When the user scrolls to this span element then render and call similar ads */}
          <span ref={similarRef}></span>
          <ActionBar
            adDetails={adDetails}
            hasPhones={hasPhones}
            isMobile={true}
            onChatClick={onChatClick}
            onCallPhoneClick={handleCallPhoneClick}
          />
          <Modal
            visible={phoneRevealState === "captchaRequired"}
            onCancel={phoneReveal.reset}
            footer={null}
            className={styles.modal}
            width={340}
          >
            <div className={styles.title}>{"Sigurnosna provjera"}</div>
            <TurnstileChallenge onSuccess={(token) => revealPhones(token)} />
          </Modal>
          {adDetails.creator && (
            <React.Fragment>
              <Modal
                visible={phoneModalVisible}
                onCancel={handlePhoneModalCancel}
                footer={null}
                className={styles.modal}
              >
                <div className={styles.title}>
                  {"Kontaktiraj oglašivača"}
                </div>
                <div className={styles.list}>
                  {phones.map((phone, i) => (
                    <div key={i} className={styles.phoneWrapper}>
                      <span className={styles.phoneTitle}>
                        {"Telefon"} {i + 1}:
                      </span>
                      <span
                        onClick={() => callCertainPhone(phone.number)}
                        className={styles.phoneNumber}
                      >
                        {phone.number}
                      </span>
                      {phone.name && <span className={styles.name}>{phone.name}</span>}
                    </div>
                  ))}
                </div>
              </Modal>
              {!isOwnAd && (
                <ContactSection
                  adSummary={adDetails.summary}
                  adId={adDetails.summary.id}
                  category={adDetails.category}
                  seller={adDetails.creator}
                  externalUrl={adDetails.summary.externalUrl}
                  hasPhones={hasPhones}
                  onCallPhoneClick={handleCallPhoneClick}
                  adTitle={adDetails.summary.title}
                  onChatClick={onChatClick}
                />
              )}
            </React.Fragment>

          )}
          {forbiddAds ? null : (
            <GoogleAd
              className={`${styles.ads} ${utilsStyles.PB2} ${utilsStyles.PT7} `}
              config={{
                ...googleAds.detailPageMobile.box4,
                id: "googleAds.detailPageMobile.box4-1"
              }}
            />
          )}
          {loadingSimilar && <Loading className={`${utilsStyles.PT20} ${utilsStyles.PB20}`} />}
          {inView && (
            <SimilarAdsSection
              category={adDetails.category}
              adId={adDetails.summary.id}
              setLoadingSimilar={(e: boolean) => setLoadingSimilar(e)}
            />
          )}
          {adDetails.module === ModuleNameHr.realEstate && isPropertyTypeSlug(adDetails.category, currentCategories) && (
            <RealEstateWidget
              category={adDetails.category}
              style={{ maxWidth: "none", marginTop: 20 }}
              label="Box detalji oglasa mobilno"
            />
          )}

          <TipsSection isMobile className={forbiddAds ? "" : utilsStyles.MB10} />
          {forbiddAds ? null : (
            <GoogleAd
              className={`${styles.ads} ${utilsStyles.MB10} ${utilsStyles.MT5} `}
              config={{
                ...googleAds.detailPageMobile.box4,
                id: "googleAds.detailPageMobile.box4-2"
              }}
            />
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

AdDetailsPageMobile.defaultProps = {
  adDetails: {},
  favoriteIds: [],
  match: {},
  user: null,
};

const ConnectedAdDetailsPageMobile = connect(
  (state: any) => ({
    adDetails: selectAdDetails(state),
    favoriteIds: selectFavoriteIds(state),
    user: selectLoadedUser(state),
    userRaw: selectUserInfo(state),
    categories: selectCategories(state),
    modules: selectModules(state)
  }),
  {
    getAdDetails,
    updateViewCount,
    getCreatorInfo,
  }
)(AdDetailsPageMobile);

export default getModuleContext(ConnectedAdDetailsPageMobile);



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/index.tsx